import React from 'react';
import ResearchItems from './ResearchItems';
import conferenceArr from './ConferenceInfo';
import journalArr from './JournalInfo';
import bookChapterArr from './BookChapterInfo';

const Research = () => {
	const journalList = journalArr.map((item, index) => (
		<ResearchItems item={item} key={index} />
	));
	const conferenceList = conferenceArr.map((item, index) => (
		<ResearchItems item={item} key={index} />
	));
	const bookChapterList = bookChapterArr.map((item, index) => (
		<ResearchItems item={item} key={index} />
	));

	return (
		<div className='container-fluid'>
			<div class='mt-3' role='alert'>
				Complete list of my publications can be found at
				<a href='https://scholar.google.com/citations?user=7sHKEusAAAAJ&hl=en'>
					&nbsp; Google Scholar
				</a>
				, and
				<a href='https://www.researchgate.net/profile/Debajyoti_Karmaker2'>
					&nbsp;ResearchGate Profile
				</a>
			</div>

			<nav>
				<div
					className='nav nav-tabs justify-content-center mt-5   '
					id='nav-tab'
					role='tablist'
				>
					<a
						className='nav-item nav-link active'
						id='nav-home-tab'
						data-toggle='tab'
						href='#nav-home'
						role='tab'
						aria-controls='nav-home'
						aria-selected='true'
					>
						Journals Articles
					</a>
					<a
						className='nav-item nav-link'
						id='nav-profile-tab'
						data-toggle='tab'
						href='#nav-profile'
						role='tab'
						aria-controls='nav-profile'
						aria-selected='false'
					>
						Conference Papers
					</a>
					<a
						className='nav-item nav-link'
						id='nav-contact-tab'
						data-toggle='tab'
						href='#nav-contact'
						role='tab'
						aria-controls='nav-contact'
						aria-selected='false'
					>
						Book Chapters
					</a>
				</div>
			</nav>
			<div className='tab-content' id='nav-tabContent'>
				<div
					className='tab-pane fade show active'
					id='nav-home'
					role='tabpanel'
					aria-labelledby='nav-home-tab'
				>
					<div className='jumbotron jumbotron-fluid'>
						<div className='d-flex  flex-wrap justify-content-center'>
							{journalList}
						</div>
					</div>
				</div>
				<div
					className='tab-pane fade'
					id='nav-profile'
					role='tabpanel'
					aria-labelledby='nav-profile-tab'
				>
					<div className='jumbotron jumbotron-fluid'>
						<div className='d-flex  flex-wrap justify-content-center'>
							{conferenceList}
						</div>
					</div>
				</div>
				<div
					className='tab-pane fade'
					id='nav-contact'
					role='tabpanel'
					aria-labelledby='nav-contact-tab'
				>
					<div className='jumbotron jumbotron-fluid'>
						<div className='d-flex  flex-wrap justify-content-center'>
							{bookChapterList}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Research;
